import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Col, Row, Button, Select, Popover } from 'antd';
// import MobileViewFilter from '../../components/MobileViewFilter/MobileViewFilter';
// import DoctorFilter from '../../components/DoctorFilter/DoctorFilter';
// import Listing from '../../components/Listing/Listing';
// import Loading from '../../components/Loading/Loading';
import google from '../../Images/google.png';
import apple from '../../Images/apple.png';
import { useLocation, useNavigate } from 'react-router-dom';
import planmysurgerybg from '../../Images/planmysurgerybg.jpg';
import { Content } from 'antd/es/layout/layout';
import { FilterOutlined } from '@ant-design/icons';
import DoctorFilter from './DoctorFilter';
import Listing from './Listing';
import { fetchDepartmentList, fetchHospitalList, fetchLocationList } from '../Home/Actions';
import { selectDepartment, selectHospital, selectLocation } from '../Home/Selectors';
import { blogListRequest, doctorListRequest } from './Actions';
import moment from 'moment';
import { selectBlogs, selectLoading, selectScheduleData } from './Selectors';
import { BodyTextHeadingListing, BodyTextKey, BodyTextNewLine, ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import CustomSpin from '../CommonSpin';
import MobileViewFilter from './MobileViewFilter';


const Search = () => {
    const dispatch = useDispatch();
    const { state } = useLocation();
    const navigate = useNavigate();

    let initialSearchParams = state;
    if (!initialSearchParams) {
        const storedParams = localStorage.getItem('quikdr_search_params');
        if (storedParams) {
            initialSearchParams = JSON.parse(storedParams);
            // Optionally clear after use
            localStorage.removeItem('quikdr_search_params');
        }
    }
    

    const [locality, setLocality] = useState(initialSearchParams?.locationState ? initialSearchParams.locationState : null);
    const [hospital, setHospital] = useState(initialSearchParams?.hospitalState ? initialSearchParams.hospitalState : null);
    const [spec, setSpec] = useState(initialSearchParams?.departmentsState ? [initialSearchParams.departmentsState] : null);
    // const [result, setResult] = useState([]);

    const [startingFee, setStartingFee] = useState(0);
    const [endFee, setEndFee] = useState(5000);
    const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().add(7, 'days').format('YYYY-MM-DD'));
    const [radio, setRadio] = useState([]);
    const [consultationType, setConsultationType] = useState([1, 2, 3, 4]);
    const [currentPage, setCurrentPage] = useState(1);
    const [doctorID, setDoctorID] = useState('');
    const [orgId, setOrgId] = useState();
    const [consultType, setConsultType] = useState();
    const [selectedResidence, setSelectedResidence] = useState(null);
    const [patientId, setPatientId] = useState(null);
    const [newpayload, setnewPayload] = useState({});


    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    const localityData = useSelector(selectLocation);
    const hospitalData = useSelector(selectHospital);
    const departmentData = useSelector(selectDepartment);
    const scheduleData = useSelector(selectScheduleData);
    const requesting = useSelector(selectLoading);
    // const requestSearch = [];
    // const clickedRequesting = [];
    const blogData = useSelector(selectBlogs);

    const payload = {
        startDate: startDate,
        endDate: endDate,
        doctorID: doctorID,
        orgId: orgId,
        consultType: consultType,
        selectedResidence: selectedResidence,
        patientId: patientId,
        initialSearchParams: {
            locationState: locality,
            hospitalState: hospital,
            departmentsState: spec ? spec[0] : null
        }
    };
    if (scheduleData && scheduleData.total > 0) {
        navigate(('/timeslot'), { state: { payload } });
    } else if (scheduleData && scheduleData.total == 0) {
        navigate(('/newtimeslot'), { state: { payload } });

    }

    useEffect(() => {
        dispatch(fetchDepartmentList(null));
        dispatch(fetchHospitalList(null));
        dispatch(fetchLocationList(null));
        dispatch(blogListRequest());
    }, [dispatch]);

    useEffect(() => {
        if (state) {
            // Update localStorage with the latest search params when state changes
            const newSearchParams = {
                locationState: state.locationState,
                hospitalState: state.hospitalState,
                departmentsState: state.departmentsState
            };
            localStorage.setItem('quikdr_search_params', JSON.stringify(newSearchParams));
            
            if (state.locationState !== undefined) setLocality(state.locationState);
            if (state.hospitalState !== undefined) setHospital(state.hospitalState);
            if (state.departmentsState !== undefined) setSpec([state.departmentsState]);
        }
    }, [state]);

    // Add a cleanup effect to remove stale search params when component unmountsAdd commentMore actions
    useEffect(() => {
        return () => {
            // Only remove if navigating away from the consultation page
            if (!window.location.pathname.includes('online-doctors-consultation')) {
                localStorage.removeItem('quikdr_search_params');
            }
        };
    }, []);    // Initial search on component mount

    useEffect(() => {
        const payload = {
            city: '',
            name: hospital ? hospital : '',
            location: locality ? locality : '',
            startdate: startDate,
            enddate: endDate,
            consult: consultationType,
            rating: '',
            gender: radio,
            orgfeelow: startingFee,
            spec: spec,
            orgfeehigh: endFee,
            page: currentPage
        };
        setnewPayload(payload);
        // Only do initial search if we have search paramsAdd commentMore actions
        if (locality || hospital || spec) {
            dispatch(doctorListRequest(payload));
            window.scrollTo(0, 0);
        }
    }, []);

    const handleDepartmentSearch = (value) => {
        if (!value) {
            dispatch(fetchDepartmentList(null));
        } else if (value.length >= 1) {
            dispatch(fetchDepartmentList(value));
        }
        // setResult([]);
    };

    const handleLocationSearch = (value) => {
        if (!value) {
            dispatch(fetchLocationList(null));
        } else if (value.length >= 1) {
            dispatch(fetchLocationList(value));
        }
        // setResult([]);
    };

    const handleHospitalSearch = (value) => {
        if (!value) {
            dispatch(fetchHospitalList(null));
        } else if (value.length >= 1 && hospital !== undefined) {
            dispatch(fetchHospitalList(value));

        }
        // setResult([]);
    };

    const onSelectlocality = (value) => {
        if (!value) {
            setLocality(null);
        } else {
            setLocality(value);
        }
        // setLocality(value);
        // localStorage.setItem('location', value);
        // localStorage.setItem('PAGE', 1);
    };

    const onSelectHospital = (value) => {

        if (!value) {
            setHospital(null);
        } else {
            setHospital(value);
        }
        // setHospital(value);
        // localStorage.setItem('hospital', value);
        // localStorage.setItem('PAGE', 1);
    };

    const onSelectDepartment = (value) => {

        if (!value) {
            setSpec(null);
        } else {
            setSpec([Number(value)]);
        }
        // localStorage.setItem('department', value);
        // departmentData.value.forEach((dep) => {
        //     if (dep.id === value) {
        //         localStorage.setItem('departmentValue', dep.specialization);
        //     }
        // });
        // localStorage.setItem('PAGE', 1);
    };

    const search = () => {
        setCurrentPage(1);
        const payload = {
            city: '',
            name: hospital ? hospital : '',
            location: locality ? locality : '',
            startdate: startDate,
            enddate: endDate,
            consult: consultationType,
            rating: '',
            gender: radio,
            orgfeelow: startingFee,
            spec: spec,
            orgfeehigh: endFee,
            page: 1
        };
        const searchParams = {
            locationState: locality,
            hospitalState: hospital,
            departmentsState: spec?.[0]
        };
        localStorage.setItem('quikdr_search_params', JSON.stringify(searchParams));
        
        // Dispatch search action and scroll to top
        dispatch(doctorListRequest(payload));
        window.scrollTo(0, 0);

    };

    // const departmentChildren = departmentData && departmentData.map(item => <Option key={item.id}>{item.specialization}</Option>);
    // const localityChildren = localityData && localityData.map(item => <Option key={item.locality}>{item.locality}</Option>);
    // const hospitalChildren = hospitalData && hospitalData.map(item => <Option key={item.name}>{item.name}</Option>);

    const departmentChildren = [];
    const locationChildren = [];
    const hospitalChildren = [];

    if (departmentData) {
        departmentData && departmentData.map((item) => {
            departmentChildren.push({
                value: item.id,
                label: item.specialization
            });
        });
    }

    if (localityData) {
        localityData && localityData.map((item) => {
            locationChildren.push({
                value: item.locality,
                label: item.locality
            });
        });
    }

    if (hospitalData) {
        hospitalData && hospitalData.map((item) => {
            hospitalChildren.push({
                value: item.name,
                label: item.name
            });
        });
    }

    // const departmentSelected = localStorage.getItem('department') || '';

    // if (requestSearch.value === true && clickedRequesting.value === true) {
    //     return <Loading />;
    // }

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const handleDepartmentFocus = () => {
        dispatch(fetchDepartmentList(null));
    };

    const handleLocationFocus = () => {
        dispatch(fetchLocationList(null));
    };

    const handleHospitalFocus = () => {
        dispatch(fetchHospitalList(null));
    };

    const handleSurgery = () => {
        if (!sessionStorage.jwt) {
            navigate('/login');
        } else {
            navigate('/plan-my-surgery');
        }
    };

    const handleConsult = () => {
        if (!sessionStorage.jwt) {
            // Store current search params and consultation intent before redirecting to login
            const currentSearchParams = {
                locationState: locality,
                hospitalState: hospital,
                departmentsState: spec?.[0],
                returnPath: '/online-doctors-consultation',
                consultationData: {
                    doctorID,
                    orgId,
                    startDate,
                    endDate,
                    consultType: 'online',
                    selectedResidence,
                    patientId
                }
            };
            localStorage.setItem('quikdr_search_params', JSON.stringify(currentSearchParams));
            navigate('/login');
        } else {
            if (scheduleData && scheduleData.total > 0) {
                navigate('/timeslot', { state: { payload } });
            } else if (scheduleData && scheduleData.total == 0) {
                navigate('/newtimeslot', { state: { payload } });
            }
        }
    };

    return (
        <Content>

            <Row justify={'center'}
                style={{
                    // marginTop: '2%',
                    marginBottom: '1%',
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                <Col span={23}>
                    <Row style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Col xs={{ span: 7 }} lg={{ span: 7 }} xl={{ span: 7 }} style={{ marginLeft: '5px', marginTop: '1%' }}>
                            <Select
                                style={{ width: '100%' }}
                                size="large"
                                onSearch={handleDepartmentSearch}
                                onChange={onSelectDepartment}
                                onFocus={handleDepartmentFocus}
                                placeholder={langdata.Department ? langdata.Department : 'Department'}
                                value={spec}
                                allowClear
                                showSearch
                                options={departmentChildren}
                                filterOption={filterOption}
                            >
                            </Select>
                        </Col>
                        <Col xs={{ span: 7 }} lg={{ span: 7 }} xl={{ span: 7 }} style={{ marginLeft: '5px', marginTop: '1%' }}>
                            <Select
                                // name="locality"
                                style={{ width: '100%' }}
                                size="large"
                                onSearch={handleLocationSearch}
                                onChange={onSelectlocality}
                                onFocus={handleLocationFocus}
                                placeholder={langdata.Location ? langdata.Location : 'Location'}
                                value={locality}
                                allowClear
                                showSearch
                                options={locationChildren}
                                filterOption={filterOption}
                            >
                            </Select>
                        </Col>
                        <Col xs={{ span: 7 }} lg={{ span: 7 }} xl={{ span: 7 }} style={{ marginLeft: '5px', marginTop: '1%' }}>
                            <Select
                                // name="hospital"
                                style={{ width: '100%' }}
                                size="large"
                                onFocus={handleHospitalFocus}
                                onSearch={handleHospitalSearch}
                                onChange={onSelectHospital}
                                placeholder={langdata.Hospital ? langdata.Hospital : 'Hospital'}
                                value={hospital}
                                allowClear
                                showSearch
                                options={hospitalChildren}
                                filterOption={filterOption}
                            >
                            </Select>
                        </Col>
                        <Col
                            xs={{ span: 23 }} // For small screens, span should take full width
                            lg={{ span: 2 }}  // For large screens, span will be 2
                            xl={{ span: 2 }}  // For extra-large screens, span will also be 2
                            style={{ marginTop: '1%', display: 'flex', justifyContent: 'center' }}
                        >
                            <Button
                                type="primary"
                                style={{
                                    background: '#1164a6',
                                    width: '90%',  // Set width to 100% for xs screens
                                    maxWidth: '100%',  // Limit the width for larger screens (90% for lg and above)
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                                size="large"
                                onClick={search}
                            >
                                <ButtonText text={langdata.Search ? langdata.Search : 'Search'} />
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row justify={'center'}>
                <Col xs={{ span: 20 }} sm={{ span: 20 }} md={{ span: 20 }} lg={{ span: 0 }} xl={{ span: 0 }} style={{ marginBottom: '1%' }}>
                    <Popover 
                        content={<MobileViewFilter 
                            setStartingFee={setStartingFee}
                            setEndFee={setEndFee}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            setRadio={setRadio}
                            setConsultationType={setConsultationType}
                            setCurrentPage={setCurrentPage}
                        />} trigger="click" placement="bottomRight">
                        <Button style={{ float: 'right' }}><FilterOutlined /></Button>
                    </Popover>
                </Col>
            </Row>
            <Row justify={'center'} style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '1%',
            }} >
                <Col span={22} >
                    <Row style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        {/* <Space> */}
                        <Col xs={{ span: 0 }} lg={{ span: 5, offset: 0 }} xl={{ span: 4, offset: 0 }}>
                            <DoctorFilter
                                setStartingFee={setStartingFee}
                                setEndFee={setEndFee}
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                                setRadio={setRadio}
                                setConsultationType={setConsultationType}
                                setCurrentPage={setCurrentPage} />
                        </Col>
                        {/* </Space> */}
                        <Col xs={{ span: 22 }} lg={{ span: 12, offset: 1 }} xl={{ span: 13, offset: 1 }}>
                            {/* <Space> */}
                            <Listing
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                startDate={startDate}
                                endDate={endDate}
                                setDoctorID={setDoctorID}
                                doctorID={doctorID}
                                setOrgId={setOrgId}
                                setConsultType={setConsultType}
                                setSelectedResidence={setSelectedResidence}
                                selectedResidence={selectedResidence}
                                setPatientId={setPatientId}
                                patientId={patientId}
                                locality={locality}Add commentMore actions
                                hospital={hospital}
                                spec={spec}
                                onConsultClick={handleConsult}
                                newPayload={newpayload}
                            />
                            {/* </Space> */}
                        </Col>
                        <Col xs={{ span: 22 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }}>
                            <Card style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <Col
                                    // md={{ span: 0 }}
                                    // lg={{ span: 16, offset: 0 }}
                                    // xl={{ span: 16, offset: 4 }}
                                    style={{
                                        cursor: 'pointer',
                                        // display : 'flex',
                                        // justifyContent : 'center'
                                    }}
                                    onClick={() => window.open('https://play.google.com/store/apps/details?id=com.quikdr.app')}
                                >
                                    <img style={{ marginTop: '15px', height: '65px' }} src={google} />
                                </Col>
                                <Col
                                    // md={{ span: 0 }}
                                    // lg={{ span: 16, offset: 0 }}
                                    // xl={{ span: 16, offset: 4 }}
                                    tyle={{
                                        cursor: 'pointer',
                                        // display: 'flex',
                                        // justifyContent: 'center'
                                    }}
                                    onClick={() => window.open('https://apps.apple.com/us/app/id1512292509')}
                                >
                                    <img style={{ marginTop: '15px', height: '65px' }} src={apple} />
                                </Col>
                            </Card>

                            <Card
                                style={{
                                    marginTop: '2%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: `url(${planmysurgerybg})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '150px' }}>
                                    {/* <Typography style={{ color: 'white', fontWeight: 'bold' }}> */}
                                    <BodyTextHeadingListing text={langdata.Planningforyoursurgery ? langdata.Planningforyoursurgery : 'Planning for your surgery?'} color='#ffffff' />
                                    {/* </Typography> */}
                                    {/* <Typography style={{ color: 'white', fontWeight: 'bold' }}> */}
                                    <BodyTextHeadingListing text={langdata.Getaconsultationtoday ? langdata.Getaconsultationtoday : 'Get a consultation today!'} color='#ffffff' />
                                    {/* </Typography> */}

                                    {/* <Link to="/plan-my-surgery"> */}
                                    {/* <button style={{ backgroundColor: '#1F66A2', color: 'white', borderRadius: '8px', marginTop: '20px' }}>
                                            
                                        </button> */}
                                    <Button
                                        type="primary"
                                        style={{
                                            background: '#1F66A2',
                                            width: '90%',  // Set width to 100% for xs screens
                                            maxWidth: '100%',  // Limit the width for larger screens (90% for lg and above)
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '15px'
                                        }}
                                        // size="large"
                                        onClick={handleSurgery}
                                    >
                                        <ButtonText text={langdata.BOOKNOW ? langdata.BOOKNOW : 'BOOK NOW'} />
                                    </Button>
                                    {/* </Link> */}
                                </div>
                            </Card>
                            {/* </Col>

                            <Col style={{ float: 'right' }} xs={{ span: 0 }} lg={{ span: 6, offset: 1 }} xl={{ span: 6, offset: 1 }} > */}
                            <div style={{ marginTop: '2%' }}>
                                <Card title={<BodyTextKey text={langdata.RELATEDTREATMENTS ? langdata.RELATEDTREATMENTS : 'RELATED TREATMENTS'} />}>
                                    {blogData && blogData.data?.map((item) => (
                                        <a key={item} href={item.blogURL} target="_blank" style={{ color: 'black' }} rel="noreferrer">
                                            <BodyTextNewLine text={item.title} />
                                        </a>
                                    ))}
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <CustomSpin spinning={requesting} />
        </Content>
    );
};

export default Search;
